import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useParams } from 'react-router-dom'
import { EDIT_BRIN } from '../../Utils/constant'
import { SubmitButton } from '../../components/Widget/SubmitButton'
import { store } from '../../services/service'
import { usePortStore } from '../../store/pboStore/listPort'


export const UpdatePort = ({ portId, defaultValue, designation }) => {
    const listPorts = usePortStore()
    const { id } = useParams()


    const {
        register,
        handleSubmit, reset,
        formState: { errors },
    } = useForm()
    const [Submit, setSubmit] = useState(false);
    const [error, setError] = useState("")
    const Editsubmit = (data) => {
        setSubmit(true)
        store(`${EDIT_BRIN}/${portId}?status=${data.status}`, 'application/json', {
            designation: data.designation
        }).then((res) => {
            if (res.status === 200) {
                listPorts.getData(`/${id}?page=0&size=8&status=`)
                document.getElementById('close_edit').click()
                toast.success('Enregistrement effectuté')
                setSubmit(false)
                reset()
            }
        }).catch((err) => {
            setSubmit(false)
            setError(err?.response?.data?.donnee)
        })
    }

    return (
        <>
            <p className='text-sm text-red-600'>{error}</p>
            <form onSubmit={handleSubmit(Editsubmit)} className="w-full  mx-auto mt-6">
                <div className="items-center gap-x-3">
                    <label className="form-control">
                        <div className="label -mb-1">
                            <span className="label-text font-medium">
                                Designation du brin <span className="text-red-500">*</span>
                            </span>
                        </div>
                        <input
                            {...register('designation', { required: true })}
                            type="text"
                            defaultValue={designation}
                            placeholder="designation du brin"
                            className="input input-bordered w-full h-10 text-sm "
                        />
                    </label>
                </div>
                <div className="items-center gap-x-3">
                    <label className="form-control">
                        <div className="label -mb-1">
                            <span className="label-text font-medium">
                                Status du port
                            </span>
                        </div>
                        <select  {...register('status', { required: true })} defaultValue={defaultValue} className="select w-full" >
                            <option disabled>
                                Status Port
                            </option>
                            <option value='LIBRE' selected>Libre</option>
                            <option value='RESERVER' >Reserver</option>
                            <option value='CONNECTER'>Connecter</option>
                            <option value='DEFECTUEUX' >Defectueux</option>
                        </select>
                    </label>
                </div>
                <SubmitButton isSubmit={Submit} label={"Enregistrer"} />
            </form>
        </>


    )
}
